import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { TextField, InputAdornment } from '~/UIKit';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '~/UIKit/Style';
import { debounce } from 'lodash-es';

const useStyles = makeStyles(() => ({
  hexColorInputWrapper: {
    width: '100%',
    flex: '1 0 100%',
  },
  input: {
    width: '100%',
  },
}));

export const HexColorInput = ({
  color,
  setColor,
}: {
  color: string;
  setColor: (color: string) => void;
}) => {
  const COLOR_HEX_PREFIX = '#';
  const colorWithNoPrix = color.substring(1);

  const [colorValue, setColorValue] = useState(colorWithNoPrix);
  const { t } = useTranslation();
  const { classes } = useStyles();

  useEffect(() => {
    if (colorWithNoPrix !== colorValue) {
      setColorValue(colorWithNoPrix);
    }
  }, [color]);

  const updateColor = useCallback(
    debounce((newColor) => {
      setColor(COLOR_HEX_PREFIX + newColor);
    }, 500),
    [],
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setColorValue(e.target.value);
    updateColor(e.target.value);
  };

  return (
    <div className={classes.hexColorInputWrapper}>
      <TextField
        className={classes.input}
        label={t('colorpicker.hex')}
        onChange={handleChange}
        value={colorValue}
        InputProps={{
          startAdornment: <InputAdornment position="start">{COLOR_HEX_PREFIX}</InputAdornment>,
        }}
      />
    </div>
  );
};
